<template>
  <div
    class="navbar"
    :class="{'navbar_collapsed': isCollapsed}"
  >
    <div class="navbar__top">
      <base-client-list v-if="!isCollapsed" />
      <ul
        class="navbar__list"
        :class="{'navbar__list_collapsed': isCollapsed}"
      >
        <template v-for="item in menuItems">
          <base-menu-item
            v-if="item.visible"
            :key="item.label"
            class="navbar__item"
            :is-collapsed="isCollapsed"
            :item="item"
            :opened-item="openedItem"
            @reveal-menu="revealMenu()"
            @click="onOpenItem($event)"
          />
        </template>
      </ul>
    </div>
    <div class="navbar__middle">
      <div class="navbar__middle__container"
        :class="{'navbar__middle__container__expanded': !isCollapsed}"
      >
        <div
          class="navbar__link cb-wizard-btn"
          :class="{'cb-wizard-btn__expanded': !isCollapsed}"
          @click="openWizard"
        >
          <span v-if="isCollapsed" class="navbar__icon-wrap navbar__cb-btn-icon"
            :class="{'navbar__cb-btn-icon__expanded': !isCollapsed}"
          >
            <base-material-design-icon
              class="navbar__icon"
              :class="{'navbar__icon__cb__expanded': !isCollapsed}"
              icon="autoFix"
            />
          </span>
          <div class="cb-btn-expanded-icons" v-else>
            <span class="navbar__icon-wrap navbar__cb-btn-icon"
              :class="{'navbar__cb-btn-icon__expanded': !isCollapsed}"
            >
              <base-material-design-icon
                class="navbar__icon"
                :class="{'navbar__icon__cb__expanded': !isCollapsed}"
                icon="autoFix"
              />
            </span>
            <span class="navbar__icon-wrap navbar__cb-btn-icon"
            >
              <base-material-design-icon
                class="navbar__icon cb-btn-forward"
                icon="arrowForward"
              />
            </span>
          </div>

          <span class="cb-wizard-btn-subtext">Quick, easy, and effortless</span>
          <span class="cb-wizard-btn-text">Create a Content Brief</span>
        </div>
      </div>
    </div>
    <div class="navbar-divider"
      :class="{'navbar-divider_collapsed': isCollapsed}"
    ></div>
    <div class="navbar__bottom">
      <div
        class="navbar__bottom-logout"
        :class="{'navbar__bottom-logout_collapsed': isCollapsed}"
      >
        <a
          class="navbar__link"
          href="https://knowledge.audiencekey.com/"
          target="_blank"
        >
          <span class="navbar__icon-wrap navbar__logout-icon">
            <base-material-design-icon
              class="navbar__icon"
              icon="education"
            />
          </span>
          <span>Knowledge Center</span>
        </a>
        <div
          class="navbar__link"
          @click="openChat"
        >
          <span class="navbar__icon-wrap navbar__logout-icon">
            <base-material-design-icon
              class="navbar__icon"
              icon="chat"
            />
          </span>
          <span>Chat Support</span>
        </div>
        <div
          class="navbar__link"
          @click="onLogout"
        >
          <span class="navbar__icon-wrap navbar__logout-icon">
            <base-material-design-icon
              class="navbar__icon"
              icon="logout"
            />
          </span>
          <span>Log Out</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Helper from '@/services/Helper'
import { mapActions, mapState } from 'vuex'

/**
 * Left side navigation panel
 * Used in the {@link MainLayout}
 */
export default {
  name: 'TheNavbar',
  props: {
    isCollapsed: Boolean,
  },
  data () {
    return {
      openedItem: ''
    }
  },
  methods: {
    ...mapActions([
      'logout',
      'changeAgencyMode',
      'changeChatStatus'
    ]),
    openWizard() {
      this.$emit('open-cb-wizard')
    },
    toggleCollapse () {
      this.$emit('collapse-toggled')
    },
    changeAgentMode (status) {
      this.changeAgencyMode(status.value)
      this.$nextTick(() => {
        // 0 - always dashboard
        this.$router.push({ name: this.menuItems[1].name })
      })
    },
    async onLogout () {
      Tawk_API.endChat()
      this.onOpenItem('logout')
      await this.logout()
      // window.location = '/user/sign-in'
      window.location.reload()
    },
    revealMenu () {
      if (this.isCollapsed) {
        this.toggleCollapse()
      }
    },
    onOpenItem (item) {
      this.openedItem = item
    },
    openChat () {
      if (this.isChatHidden) {
        window.Tawk_API.showWidget()
      } else {
        window.Tawk_API.hideWidget()
      }
      this.changeChatStatus()
    }
  },
  computed: {
    ...mapState(['isChatHidden']),
    userInitials: function () {
      return Helper.getInitialsFromEmail(this.email)
    },
    email () {
      return this.currentUser ? this.currentUser.email : ''
    }
  }
}
</script>

<style scoped lang="scss">
  .cb-btn-forward {
    align-self: flex-start;
    margin-top: -5px;
    margin-left: 0px;
    transition: margin ease 0.25s;

  }
  .cb-btn-expanded-icons {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .navbar-divider {
    border-bottom: 1px solid #e7e9eb;
    margin: 10px 20px 10px 12px;
    &_collapsed {
      margin-left: 22px;
      margin-right: 22px;
    }
  }
  .cb-wizard-btn-text {
    color: #011627;
  }
  .cb-wizard-btn-subtext {
    color: #2F404E;
    font-size: 10px;
    font-weight: initial;
  }
  .cb-wizard-btn {
    background-color: #EAF7F6;
    border-radius: 6px;
    height: 40px !important;
    &:hover {
      background-color: #54CEC3 !important;
      .cb-btn-forward {
        margin-left: 5px;
      }
    }
    &__expanded {
      padding-left: 24px;
      padding-top: 16px;
      flex-direction: column-reverse;
      height: 70px !important;
      justify-content: space-between;
      align-items: flex-start !important;
      &:hover {
        background-color: #EAF7F6 !important;
      }
    }
  }
  .navbar {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    white-space: nowrap;
    background-color: #fff;

    &__icon__cb__expanded {
      font-size: 40px;
    }

    &_collapsed {
      position: relative;

      .navbar__icon-wrap {
        padding-left: 10px;
        width: 100%;
        margin-right: 100px;
      }
    }

    &__agency-mode {
      padding: 10px 21px;

      &__label {
        margin-left: 10px;
      }
    }

    &__item {
      padding: 5px 22px;
      height: 50px;
      box-sizing: border-box;
    }

    &__list {
      list-style-type: none;
      padding: 0;
      margin: 0 -2px;

      &_collapsed{
        margin-left: -8px;
      }
    }

    &__link {
      display: flex;
      align-items: center;
      text-decoration: none;
      color: $rfx-dark-march;
      font-weight: 500;
      height: 100%;

      &_active,
      &:hover {
        border-radius: 4px;
        background-color: rgba(1, 22, 39, 0.1);
      }

      &:hover {
        /*background: linear-gradient(to right, rgba(40, 74, 255, 0.13), rgba(40, 74, 255, 0));*/
      }
    }

    &__icon-wrap {
      display: flex;
      width: 24px;
      flex: 0 0 24px;
      padding-left: 10px;
      justify-content: center;
      margin-right: 15px;
      font-size: 22px;
    }

    &__collapse-icon {
      display: flex;
      width: 23px;
      flex: 23px 0 0;
      height: 23px;
      color: inherit;
      background-color: currentColor;
      border-radius: 50%;
      align-items: center;
      justify-content: center;
      margin: 0 30px 0 37px;

      &::before {
        content: "";
        display: block;
        border-right: 12px dashed $rfx-grey;
        border-top: 7px solid transparent;
        border-bottom: 7px solid transparent;
        margin-left: -3px;
      }

      &_turned::before {
        transform: rotate(180deg);
        margin-left: 3px;
      }
    }

    &__top {
    }
    &__middle {
      flex-shrink: 2;
      &__container {
        cursor: pointer;
        padding-left: 22px;
        padding-right: 22px;
        &__expanded {
          overflow-y: hidden;
          padding-left: 12px;
          padding-right: 20px;
        }
      } 
      
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      &_collapsed {
        padding: 0 22px;
      }
    }
    &__bottom {
      height: 140px;
      flex-grow: 2;
    }

    &__bottom-account {
      height: 40px;
      padding: 5px 20px 5px 12px;

      &_collapsed {
        padding: 5px 22px;
      }
    }

    &__integrations {
      height: 40px;
      padding: 0 20px;
      object-fit: scale-down;
      object-position: left;
      margin-left: -1px;

      &_collapsed {
        padding: 0 22px;
      }

      &_icon_collapsed {
        margin-left: -7px;
        margin-right: 105px;
      }
    }

    &__integrations {
      height: 40px;
      padding: 0 20px;

      &_collapsed {
        padding: 0 22px;
      }

      &_icon_collapsed {
        margin-left: -5px;
        margin-right: 105px;
      }
    }

    &__bottom-logout {
      height: 40px;
      cursor: pointer;
      padding-left: 12px;
      padding-right: 20px;

      &_collapsed {
        padding: 0 22px;
      }
    }

    &__logout-icon {
      margin-right: 15px;
      padding-left: 25px;
    }
    &__cb-btn-icon__expanded {
      padding-left: 0;
      margin-bottom: -10px;
    }
  }

  .select {
    border-bottom: 1px solid rgba(1, 22, 39, 0.1);

    &__title {
      display: flex;
      align-items: center;
      height: 30px;
      text-transform: uppercase;
      opacity: 0.4;
      color: $rfx-dark-march;
      font-size: 12px;
      padding-left: 30px;
      margin-top: 10px;
    }

    &__list-wrap {
      position: absolute;
      min-width: 100%;
      max-width: 350px;
      cursor: default;
      top: 100%;
      left: 0;
    }

    &__overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1000;
    }

    &__list {
      padding: 0;
    }

    &__projects-list {
      max-height: 155px;
      padding: 0 0 4px;
      list-style-type: none;
      margin: 6px 0 0;
      overflow-x: hidden;
      overflow-y: hidden;

      &_opened {
        max-height: none;
      }
    }

    &__item {
      display: block;
      padding: 0 20px 0 30px;
      height: 30px;
      line-height: 30px;
      color: $rfx-dark-march;
      font-size: 12px;
      cursor: pointer;
      font-weight: 500;
      @include ellipsis;

      &_active {
        /*<!--background-color: $rfx-light-blue;-->*/
        color: $rfx-light-blue;
      }

      &:not(:first-child):hover {
        opacity: 0.4;
      }

      &:first-child {
        /*<!--border-top: 2px solid $rfx-blue-medium;-->*/
      }

      &:last-child {
        /*<!--border-bottom-left-radius: $rfx-default-border-radius;-->*/
        /*<!--border-bottom-right-radius: $rfx-default-border-radius;-->*/
      }
    }

    &__dots {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 32px;
      margin-top: -20px;
    }

    &__show-more,
    &__show-less {
      position: relative;
      display: flex;
      align-items: center;
      font-size: 12px;
      color: $rfx-bright-blue;
      height: 30px;
      width: 85px;
      margin-left: 30px;
      margin-bottom: 6px;
      cursor: pointer;

      &::after {
        display: block;
        position: absolute;
        content: '';
        width: 5px;
        height: 5px;
        border-left: 3px solid $rfx-bright-blue;
        border-bottom: 3px solid $rfx-bright-blue;
        border-radius: 1px;
        transform: rotate(-45deg);
        top: 10px;
        right: 0;
      }
    }

    &__show-less {
      &::after {
        transform: rotate(135deg);
        top: 13px;
      }
    }

  }

  .user-info {
    display: flex;
    align-items: center;
    position: relative;
    padding-right: 25px;
    cursor: pointer;

    &__icon {
      display: flex;
      width: 30px;
      height: 30px;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      color: #fff;
      font-size: 16px;
      text-transform: uppercase;
      border-radius: 50%;
      background-color: $rfx-bright-turquoise;
      -webkit-print-color-adjust: exact;
      margin-right: 15px;
      margin-left: 20px;
      font-weight: normal;

      &_collapsed {
        flex: 0 0 30px;
        margin-right: 100px;
        margin-left: 8px;
      }


      &_disabled {
        pointer-events: none;
      }

      /*<!--&::after {-->*/
      /*<!--  display: block;-->*/
      /*<!--  position: absolute;-->*/
      /*<!--  content: '';-->*/
      /*<!--  width: 8px;-->*/
      /*<!--  height: 8px;-->*/
      /*<!--  border-left: 2px solid $rfx-medium-march;-->*/
      /*<!--  border-bottom: 2px solid $rfx-medium-march;-->*/
      /*<!--  transform: rotate(-45deg) translate(-12px, 10px);-->*/
      /*<!--  top: 0;-->*/
      /*<!--  right: 0;-->*/
      /*<!--}-->*/

      &_shrunk {
        width: 30px;
        height: 30px;
        font-size: 18px;

        &::after {
          transform: rotate(-45deg) translate(-9px, 6px);
        }
      }
    }

  }
</style>
